<template>
  <div class="form-group package-setting-select">
    <label v-if="fieldLabel" class="form-control-label" :for="id">
      {{ fieldLabel }}
    </label>
    <vue-select
      :disabled="readonly"
      :multiple="multiple"
      @input="onChange"
      :value="selectedVal"
      :options="options"
      label="name"
      :id="id"
      v-model="selectedVal"
      :class="addClass"
      :searchable="false"
      class="veri-dagitim-selectbox"
    >
      <template
        #selected-option="{ name, price, fundAmount, commissionAmount }"
      >
        <div>
          <p>{{ name }} ({{ price }} TL)</p>
          <p class="small-text m-text-grayscale-60" style="margin-top: 5px">
            BES&nbsp;/&nbsp;Komisyon: {{ formatPrice(fundAmount) }}&nbsp;TL /
            {{ formatPrice(commissionAmount) }}&nbsp;TL
          </p>
        </div>
      </template>
    </vue-select>
    <span v-if="error === true" class="select-error">{{ errorText }}</span>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import mixins from "../../mixins/index";
export default {
  name: "PackageSettingSelect",
  mixins: [mixins],
  props: {
    fieldLabel: String,
    options: Array,
    id: String,
    error: Boolean,
    errorText: String,
    defaultValue: Number,
    selectedId: Number || String,
    readonly: Boolean,
    multiple: Boolean,
  },
  components: {
    VueSelect,
  },
  data() {
    return {
      selectedVal: this.options[0],
    };
  },
  mounted() {
    this.changeToDefaultValue();
  },
  methods: {
    onChange() {
      this.$emit("change", this.selectedVal ? this.selectedVal : null);
    },
    reset() {
      this.selectedVal = "";
    },
    changeToDefaultValue() {
      if (this.defaultValue) {
        this.selectedVal = this.options.find((o) => o.id === this.defaultValue);
      }
    },
    changeToSpecificValue(id) {
      this.selectedVal = this.options.find((o) => o.id === id);
    },
    /**
     * determines selected value for single select
     * @param {String | Number} val
     */
    selectDetermineSelectedValue(val) {
      this.selectedVal = val
        ? this.options.filter((o) => o.option == val)
        : this.options[0];
    },
    /**
     * determines selected value for multiselect
     * @param {Array} val
     */
    multiSelectDetermineSelectedValue(val) {
      if (!val || !val.length) this.selectedVal = this.options[0];
      else {
        this.selectedVal = val.map((v) =>
          this.options.find((o) => o.option == v)
        );
      }
    },
  },
  computed: {
    addClass() {
      return [{ error: this.error }, { readonly: this.readonly }];
    },
  },
  watch: {
    selectedId(val) {
      if (typeof val === "number" || typeof val === "string") {
        this.selectDetermineSelectedValue(val);
      } else {
        this.multiSelectDetermineSelectedValue(val);
      }
    },
    options(val) {
      this.selectedVal = val[0];
    },
  },
};
</script>

<style lang="scss">
.osm-vd {
  .form-group {
    &.package-setting-select {
      position: relative;
      height: 45px;
      display: flex;
      @media (max-width: 768px) {
        height: auto !important;
      }
      .veri-dagitim-selectbox.v-select {
        width: 100%;
        background: transparent !important;
        display: flex;

        .vs__dropdown-toggle .vs__selected {
          font-size: 12px;
        }
        @media (max-width: 740px) {
          .vs__actions {
            right: 0;
          }
        }
        @media (max-width: 340px) {
          .vs__actions {
            right: 34px;
          }
        }
        &.error {
          border-color: var(--red);
          border-radius: var(--radius-first);
          .vs__dropdown-toggle {
            svg {
              fill: var(--red);
            }
          }
        }
        &.vs--open {
          border-color: var(--green);
        }
        .vs {
          &__dropdown-toggle {
            /*padding: 0.625rem 0.25rem 0.625rem 0.6rem;*/
            border: none;
            background: transparent !important;
            min-width: 200px;
            svg {
              fill: rgb(71, 71, 71);
            }
          }
          &__search,
          &__selected,
          &__dropdown-menu li {
            font-size: 14px;
          }
          &__selected {
            width: 100% !important;
            color: #000;
          }
          &__dropdown-option--highlight {
            background: #000;
            color: #fff !important;
          }
        }
        &.vs--disabled {
          .vs__dropdown-toggle,
          .vs__search,
          .vs__clear,
          .vs__open-indicator {
            background: #e9ecef !important;
          }
        }
      }

      .select-error {
        display: block;
        color: var(--red);
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
      }

      .readonly {
        .vs__actions {
          display: none;
        }
      }
    }
  }
}
</style>
